import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, {
      layout: "inline",
      style: {"margin-bottom":"16px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "用户ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.searchForm.userId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.userId) = $event)),
              placeholder: "请输入用户ID",
              "allow-clear": "",
              style: {"width":"160px"}
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "广告账户ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.searchForm.adsId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.adsId) = $event)),
              placeholder: "请输入广告账户ID",
              "allow-clear": "",
              style: {"width":"180px"}
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: _ctx.searchForm.type,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.type) = $event)),
              placeholder: "全部",
              "allow-clear": "",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode("自动")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("手动")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "用户类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              value: _ctx.searchForm.userType,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.userType) = $event)),
              placeholder: "全部",
              "allow-clear": "",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode("外部")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("内部")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "日期范围" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_range_picker, {
              value: _ctx.searchForm.timeRange,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.timeRange) = $event)),
              valueFormat: _ctx.dateFormat,
              style: {"width":"260px"}
            }, null, 8, ["value", "valueFormat"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.search
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              style: {"margin-left":"8px"},
              onClick: _ctx.reset
            }, {
              default: _withCtx(() => [
                _createTextVNode("重置")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              style: {"margin-left":"8px"},
              type: "primary",
              loading: _ctx.exportLoading,
              onClick: _ctx.exportXls
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 回收导出xls ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_XAtable, {
      columns: _ctx.columns,
      dataSource: _ctx.tableData,
      loading: _ctx.loading,
      scroll: { x: 1200 }
    }, null, 8, ["columns", "dataSource", "loading"]),
    _createVNode(_component_a_pagination, {
      current: _ctx.pageNo,
      "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageNo) = $event)),
      onChange: _ctx.pageNoChange,
      total: _ctx.total,
      "page-size": _ctx.pageSize,
      hideOnSinglePage: "",
      onShowSizeChange: _ctx.showSizeChange,
      style: {"margin-top":"16px","text-align":"right"}
    }, null, 8, ["current", "onChange", "total", "page-size", "onShowSizeChange"])
  ]))
}